export default __webpack_public_path__ + "static/media/3c.c6b90458.svg";